import { components } from 'react-select'

const ShowAllResults = ({ onClick, ...props }) => (
    <components.MenuList {...props}>
        {props.children}
        <button className="select__show-all-results" onClick={onClick}>
            <T>input.placeholder.show.all.results</T>
        </button>
    </components.MenuList>
)

export default ShowAllResults
